// extracted by mini-css-extract-plugin
export default {"root":"profile_edit_nav___root___d578ca23"};